import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  description: PropTypes.string,
  children: PropTypes.node,
};

const ListingActionsCard = ({
  className,
  icon,
  title,
  description,
  children,
}) => {
  const classes = classNames({
    'listing-action-card': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div>
        <p className="listing-action-card-icon">{icon}</p>
        <p className="listing-action-card-title">{title}</p>
        {description && (
          <p className="listing-action-card-description">{description}</p>
        )}
      </div>

      <div>{children}</div>
    </div>
  );
};

ListingActionsCard.propTypes = propTypes;

export default ListingActionsCard;
